import { render, staticRenderFns } from "./TextFramed.vue?vue&type=template&id=dd6ca2fc&scoped=true&"
import script from "./TextFramed.vue?vue&type=script&lang=ts&"
export * from "./TextFramed.vue?vue&type=script&lang=ts&"
import style0 from "./TextFramed.vue?vue&type=style&index=0&id=dd6ca2fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../home/bearlogin/development/pinq-project/mono2/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6ca2fc",
  null
  
)

export default component.exports